import { render, staticRenderFns } from "./ToothSelector.vue?vue&type=template&id=2db6f7f9&scoped=true"
import script from "./ToothSelector.vue?vue&type=script&lang=js"
export * from "./ToothSelector.vue?vue&type=script&lang=js"
import style0 from "./ToothSelector.vue?vue&type=style&index=0&id=2db6f7f9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db6f7f9",
  null
  
)

export default component.exports